import { render, staticRenderFns } from "./DashboardInvitations.vue?vue&type=template&id=1824044e"
import script from "./DashboardInvitations.vue?vue&type=script&lang=js"
export * from "./DashboardInvitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports